
import Vue from "vue"
import { Component } from "vue-property-decorator"

import router from "@/router/router"

Component.registerHooks(["beforeRouteEnter"])

@Component({})
export default class ReportsMainView extends Vue {
    beforeRouteEnter(to: any, from: any, next: any) {
        const regex = new RegExp("^/sections/reports/?$")
        const result = (to.path as string).match(regex)

        if (result) {
            router.push({ path: "/sections/reports/services_received" })
        } else {
            next()
        }
    }
}
